import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AdvantagesSection from "./components/AdvantagesSection";
import ApplicationsSection from "./components/ApplicationsSection";
import SolutionsSection from "./components/SolutionsSection";
import ProductsSection from "./components/ProductsSection";
import StatsSection from "./components/StatsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import VideosSection from "./components/VideosSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ApplicationsSection />
        <SolutionsSection />
        <AdvantagesSection />
        <StatsSection />
        <WhyChooseSection />
        <ProductsSection />
        <VideosSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
